import React from 'react';
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import '../../../../static/styles/apiguide.scss';
import '../../../../static/styles/dashboard.scss';

export default class UpdateTourInventoryByDateV2 extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const col_number_8 = 8;
        const total_levels = 6;
        const level1 = 5;
        const level2 = 4;
        const level2_prefix = level1 - level2;
        const level3 = 3;
        const level3_prefix = level1 - level3;
        const level4 = 2;
        const level4_prefix = level1 - level4;
        const level5 = 1;
        const level5_prefix = level1 - level5;
        return (
            <div id={"update-inventory-by-date"}>
                {/*<h3 className={"mb0 mt40"}>6. 여행상품 부분 업데이트 API</h3>*/}
                <h3 className={"mb0 mt40"}>요금/수량</h3>

                <div className="blog-post-meta">
                    <span className="s-post">상품 옵션의 요금 및 수량을 등록/업데이트 할 수 있습니다.</span>
                    <h3 className="request-method">
                        <span className="label label-success">POST</span>
                    </h3>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <td>Path</td>
                            <td>Example Endpoint</td>
                        </tr>
                        <tr>
                            <td>/v2/marketplace/fill/inventories</td>
                            <td>
                                https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v2/marketplace/fill/inventories
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt10">
                    <h4>Request Parameters</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th colSpan={col_number_8} className="bold">Request Header</th>
                        </tr>
                        <tr>
                            <th colSpan={level1}>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td colSpan={level1}>Request-Vendor-Id</td>
                            <td>O</td>
                            <td>String</td>
                            <td>벤더 아이디</td>
                        </tr>
                        <tr>
                            <th colSpan={col_number_8} className="bold">Body Parameter</th>
                        </tr>
                        <tr>
                            <th colSpan={level1}>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td colSpan={level1}>inventoryDtos</td>
                            <td>O</td>
                            <td>Array</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>travelProductId</td>
                            <td>O</td>
                            <td>Long</td>
                            <td>쿠팡 상품 아이디</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>productType</td>
                            <td>O</td>
                            <td>String</td>
                            <td>상품타입. Example: TOUR</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>itemWithStockAndPriceList</td>
                            <td>O</td>
                            <td>Array</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>travelItemId</td>
                            <td>O</td>
                            <td>Long</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>targetDate</td>
                            <td>O</td>
                            <td>LocalDate</td>
                            <td>요금/수량 등록일자. Format: yyyy-MM-dd</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>rateWithStockAndPrice</td>
                            <td>O</td>
                            <td>Map</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level4}>key</td>
                            <td>O</td>
                            <td>String</td>
                            <td>
                                <table className="table table-striped">
                                    <tbody>
                                        <tr>
                                            <th>Optional Value</th>
                                            <th>Description</th>
                                        </tr>
                                        <tr>
                                            <td>ADULT</td>
                                            <td>성인</td>
                                        </tr>
                                        <tr>
                                            <td>CHILD</td>
                                            <td>아동</td>
                                        </tr>
                                        <tr>
                                            <td>TODDLER</td>
                                            <td>유아</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level4}>value</td>
                            <td>O</td>
                            <td>Object</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level5}>stock</td>
                            <td>O</td>
                            <td>Integer</td>
                            <td>재고수량</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level5}>price</td>
                            <td>O</td>
                            <td>Double</td>
                            <td>판매가</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h3 className="panel-title"></h3>
                            <a data-toggle="collapse" href = "#patchInventoryDto">Request Body</a>
                        </div>
                        <div id = "patchInventoryDto" className = "panel-collapse collapse">
                            <div id = "createTourDto" className="panel-body">
                    <pre className="ty01">
                        {`
[
    {
        "travelProductId": 542694088235810800,
        "productType": "TOUR",
        "itemWithStockAndPriceList": [
            {
                "travelItemId": 542694088655241200,
                "targetDate": "2020-02-25",
                "rateWithStockAndPrice": {
                    "ADULT": {
                        "stock": 10,
                        "price": 2500000
                    }
                }
            },
            {
                "travelItemId": 542694088818819100,
                "targetDate": "2020-02-25",
                "rateWithStockAndPrice": {
                    "ADULT": {
                        "stock": 20,
                        "price": 3500000
                    }
                }
            }
        ]
    }
]
                        `}
                    </pre>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="table-responsive mt40">
                    <h4>Response Specifications</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>code</td>
                            <td>String</td>
                            <td>응답 코드</td>
                        </tr>
                        <tr>
                            <td>message</td>
                            <td>String</td>
                            <td>응답 메세지</td>
                        </tr>
                        <tr>
                            <td>data</td>
                            <td>String</td>
                            <td>null</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h3 className="panel-title">응답값 예시</h3>
                        </div>
                        <div className="panel-body">
                    <pre className="ty01">
                        {`
        {
            "code": 200
            "message" : "Partial Update Ticket Inventory Request accepted"
            "data" : null
        }
                        `}
                    </pre>
                        </div>
                    </div>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th>HTTP CODE</th>
                            <th>message</th>
                            <th>설명</th>
                        </tr>
                        <tr>
                            <td>400</td>
                            <td>Bad request</td>
                            <td>요청 파라미터 값이 정확하지 않을 경우에 발생합니다</td>
                        </tr>
                        <tr>
                            <td>401</td>
                            <td>Unauthorized Error</td>
                            <td>잘못된 인증 정보</td>
                        </tr>
                        <tr>
                            <td>403</td>
                            <td>Forbidden Error</td>
                            <td>클라이언트 에서 인증을 제공하였으나 접속 허가를 받지 못했을 경우에 발생합니다.</td>
                        </tr>
                        <tr>
                            <td>410</td>
                            <td>The resource has been permanently deleted</td>
                            <td>리소스가 삭제되었을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>412</td>
                            <td>Precondition failed</td>
                            <td>전제조건이 충족하지 않아 요청이 처리되지 않을 경우에 발생합니다</td>
                        </tr>
                        <tr>
                            <td>429</td>
                            <td>Too many requests</td>
                            <td>요청이 많을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>504</td>
                            <td>API Gateway response timeout</td>
                            <td>API 게이트웨이 응답시간 초과할 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>521</td>
                            <td>API provider server has error</td>
                            <td>API 프로바이더 서버에 에러가 있을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>524</td>
                            <td>API provider to API gateway connection response timeout</td>
                            <td>API 프로바이더에서 API 게이트웨이 연결 응답 시간 초과할 경우 발생합니다</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/apis/TourAPIContent/V2/ProductAPI/UpdateTourInventoryByDateV2.jsx